// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","brand":"Navbar_brand__wAuKA","navItems":"Navbar_navItems__nmbHp"};